// how long typing must pause before a user search goes out
export const USER_SEARCH_DELAY = 300

// A search for a field the user types in: it waits until typing pauses,
// sends only the last query, and gives null to every call a newer one
// replaced, also when that older reply comes back late. run.cancel()
// drops what is waiting.
export const latestSearch = (search, delay = USER_SEARCH_DELAY) => {
  let latest = 0
  let timer = null
  let dropWaiting = null

  const run = (query) => {
    const call = ++latest
    window.clearTimeout(timer)
    dropWaiting?.()
    return new Promise((resolve, reject) => {
      dropWaiting = () => resolve(null)
      timer = window.setTimeout(() => {
        dropWaiting = null
        search(query).then(
          (result) => resolve(call === latest ? result : null),
          (error) => (call === latest ? reject(error) : resolve(null)),
        )
      }, delay)
    })
  }

  run.cancel = () => {
    latest++
    window.clearTimeout(timer)
    dropWaiting?.()
    dropWaiting = null
  }

  return run
}
